<div class="row d-flex align-items-center">
  <div class="col-sm-12">
    <h2 class="text-primary mb-0">
      {{cardConfiguration.title}}
    </h2>
    <br />
    {{'IncapacityEvaluation.Info1' | translate}}
  </div>
</div>
<br />

<div class="form-group">
  <div class="row">
    <div class="col-sm-12">
      <label for="IncapacityEvalReport">
        <span class="mandatory">*</span>{{'IncapacityEvaluation.IncapacityEvalReport' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.IncapacityEvaluation.IncapacityEvalReport' | translate}}"></span>
      </label>
    </div>
    <div class="col-sm-4">
      <div class="btn-group btn-group-toggle">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.incapacityEvalReport" [radioLabel]="incapacityEvalReport">
          <input type="radio" [(ngModel)]="cardData.incapacityEvalReport" name="incapacityEvalReport" #incapacityEvalReport="ngModel" [value]="domain.value" required>
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>
</div>

<div class="form-group">
  <div class="row">
    <div class="col-sm-12">
      <label for="VideoCallExam">
        <span class="mandatory">*</span>
        {{(isWorkflowOnSubscriber ? 'IncapacityEvaluation.VideoCallExamSub' : 'IncapacityEvaluation.VideoCallExamSer') | translate}}
      </label>
    </div>
    <div class="col-sm-4">
      <div class="btn-group btn-group-toggle">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.videocallExam" [radioLabel]="videocallExam">
          <input type="radio" [(ngModel)]="cardData.videocallExam" name="videocallExam" #videocallExam="ngModel" [value]="domain.value" required />
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>

    </div>
  </div>
</div>


<div class="form-group">
  <div class="row">

    <div class="col-sm-12">
      <label for="VideocallLocation">
        <span *ngIf="cardData.videocallExam?.toString()=='true'" class="mandatory">*</span>{{'IncapacityEvaluation.VideocallLocation' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.IncapacityEvaluation.VideocallLocation' | translate}}"></span>
      </label>
    </div>
    <div class="col-sm-4">
      <fieldset [disabled]="(!cardData.videocallExam || cardData.videocallExam?.toString() != 'true')">
        <div class="btn-group btn-group-toggle w-100">
          <label *ngFor="let domain of videocallLocations" tabindex="0" class="btn btn-toogle"
                 [class.active]="(domain.code==cardData.videocallLocation) && !(!cardData.videocallExam || cardData.videocallExam?.toString() != 'true')"
                 [radioLabel]="videocallLocation">
            <input type="radio" [(ngModel)]="cardData.videocallLocation" #videocallLocation="ngModel" name="videocallLocation" [value]="domain.code"
                   [required]="cardData.videocallExam?.toString()=='true'"
                   [disabled]="!cardData.videocallExam || cardData.videocallExam?.toString() != 'true'">
            {{domain.description}}
          </label>
          <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
        </div>
      </fieldset>
    </div>

    <div class="col-sm-12">{{'IncapacityEvaluation.Info2' | translate}}</div>

  </div>
</div>

<div class="form-group">
  <div class="row">
    <div class="col-sm-12">
      <label for="IsSubscInIsolation">
        <span class="mandatory">*</span>{{(isWorkflowOnSubscriber ? 'IncapacityEvaluation.IsSubscInIsolationSub' : 'IncapacityEvaluation.IsSubscInIsolationSer') | translate}}
      </label>
    </div>
    <div class="col-sm-4">
      <div class="btn-group btn-group-toggle">
        <label *ngFor="let domain of yesNo.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.isSubscInIsolation" [radioLabel]="isSubscInIsolation">
          <input type="radio" [(ngModel)]="cardData.isSubscInIsolation" name="isSubscInIsolation" #isSubscInIsolation="ngModel" [value]="domain.value" required
                 [clearRelated]="{model : this.cardData , propsToReset : ['isolationUntil']} ">
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>
</div>


  <div class="row">
    <div class="col-sm-4">
      <label for="IsolationUntil" [ngClass]="(!cardData.isSubscInIsolation || cardData.isSubscInIsolation?.toString() != 'true') ? 'disabled' : '' ">
        <span *ngIf="cardData.isSubscInIsolation?.toString()=='true'" class="mandatory">*</span>{{'IncapacityEvaluation.IsolationUntil' | translate}}
      </label>

      <div class="input-group">
        <input #dpIsolationUntil="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
               [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
               [(ngModel)]="cardData.isolationUntil" name="isolationUntil" #isolationUntil="ngModel"
               [required]="cardData.isSubscInIsolation?.toString()=='true'"
               [disabled]="!cardData.isSubscInIsolation || cardData.isSubscInIsolation?.toString() != 'true'"
               [minDate]="currentDate"
               [maxDate]="currentMaxDate"
               maxlength="10"
               placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
               (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" >
        <div class="input-group-append disable-on-fieldset" (click)="!dpIsolationUntil.isDisabled && dpIsolationUntil.toggle()">
          <span class="input-group-text" id="basic-addon2">
            <i class="icon-calendar"></i>
          </span>
        </div>
        <validation-message [control]="isolationUntil"></validation-message>
      </div>
    </div>
  </div>



